import React from 'react';
import {
    Footer as LayoutComponentFooter
} from '@vtblife/layout-components';
import { errorCatcherWrap } from '@search/error/src/catcher';
import { MenuItemComponentProps } from '@vtblife/layout-components/dist/types/menu-item.interface';
import {
    FooterLink,
    FooterMiddleCol,
    FooterPhoneType,
} from '@vtblife/layout-components/dist/types/footer.interface';
import { FooterLink as FooterLinkConfig } from '@vtblife/layout-config/dist/types';

import { graphql, useGql } from '@search/gql-client/src';
import type { FooterQuery$data as FooterQueryResponse, FooterQuery$variables as FooterQueryVariables } from './__generated__/FooterQuery.graphql';

const query = graphql`
    query FooterQuery($regionId: Int) {
        footer(regionId: $regionId) {
            downloadAppQrCode
            socialLinks {
                name
                icon
                href
            }
            top {
                to
                name
                href
                cdn
            }
            middleLinks {
                title
                links {
                    to
                    href
                    cdn
                    name
                }
            }
        }
    }
`;

const FooterMenuItemComponent: React.FC<MenuItemComponentProps> = props => {
    const { url = '/', path, ...rest } = props;

    return <a key={url} href={url === 'undefined' ? path : url} {...rest} />;
};

const Footer: React.FC<{
    buildLink?: (url: string) => string;
    phone?: FooterPhoneType;
    regionId?: number;
}> = ({ regionId, ...props }) => {
    const { data } = useGql<FooterQueryVariables, FooterQueryResponse>(query, { regionId });

    const { top, middleLinks: rawMiddleLinks, downloadAppQrCode, socialLinks = [] } = data?.footer || {};

    const buildLink = (link: FooterLinkConfig) => {
        const url = (link.to || link.href) as string;
        const absoluteUrl = props.buildLink ? props.buildLink(url) : url;

        return {
            ...link,
            href: link.cdn ? url : absoluteUrl
        };
    };

    const topLinks: Array<Array<FooterLink>> = (top || [])
        .map(links => (links || [])
            .map(link => buildLink(link as FooterLinkConfig))
        );

    const middleLinks: Array<FooterMiddleCol> = (rawMiddleLinks || [])
        .map(column => ({
            title: column!.title,
            links: (column!.links || []).map(link => buildLink(link as FooterLinkConfig))
        }));

    return (
        <LayoutComponentFooter
            top={topLinks}
            middle={middleLinks}
            menuItemComponent={FooterMenuItemComponent}
            phone={props.phone}
            socialLinks={socialLinks}
            downloadAppQrCode={downloadAppQrCode}
        />
    );
};

export default errorCatcherWrap(Footer);
